import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-text-lighter md:text-sm sm:text-xs" }
const _hoisted_2 = { class: "lg:text-xl md:text-base sm:text-sm font-semibold text-text" }
const _hoisted_3 = { class: "text-text-lighter md:text-sm sm:text-xs" }
const _hoisted_4 = { class: "text-text-lighter md:text-sm sm:text-xs" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("View publication")

import { SearchResponse } from '@/models/Search';
import OpenDoi from '@/components/Buttons/OpenDoi.vue';
import { computed, PropType } from 'vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  props: {
  entity: {
    type: Object as PropType<SearchResponse>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const selectedEntityId = computed(
  () => store.getters['search/selectedEntityId'] as number | undefined
);
const isSelected = computed(() => {
  return selectedEntityId.value && selectedEntityId.value === props.entity.entity.id;
});
const setSelectedEntityId = async () => {
  store.dispatch('search/setSelectedEntityId', props.entity.entity.id);
};

const authorsShort = (result: SearchResponse) => {
  let res = '';
  let authlength = result.entity.authors.length;

  let count = 0;
  for (let j = 0; j < authlength; j++) {
    if (j < 3) {
      res += result.entity.authors[j].name;
      if (j < authlength - 1) res += ', ';
    }
    count++;
  }
  if (count > 4) {
    res += ' ... ';
    res += result.entity.authors[authlength - 1].name;
    res += ' +' + count + ' more';
  }
  return res;
};

const citAndRefs = (cit: number, refs: number[]) => {
  let res = '';

  // citations
  res += cit;
  if (cit == 1) res += ' Citation';
  else res += ' Citations';

  // divider
  res += ' | ';

  // references
  let refsCount = 0;
  if (refs != null) refsCount = refs.length;
  res += refsCount;
  if (refsCount == 1) res += ' Reference';
  else res += ' References';

  return res;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["p-2 mb-2 border border-gray-200 rounded cursor-pointer active:bg-primary-light text-left w-full", {
      'border-primary-light': _unref(isSelected),
      'bg-primary-lightest': _unref(isSelected),
    }]),
    onClick: setSelectedEntityId
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.entity.entity?.publisher) + " (" + _toDisplayString(__props.entity.entity?.year) + ") ", 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(__props.entity.entity?.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(authorsShort(__props.entity)), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(citAndRefs(__props.entity.entity?.citationCount, __props.entity.entity?.refs)), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "py-2 mr-2 mt-1 md:text-base sm:text-sm font-semibold text-text-lighter focus:outline-none hover:text-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('moreInformation', __props.entity.entity.id)))
      }, " More information "),
      (__props.entity?.entity?.doi)
        ? (_openBlock(), _createBlock(OpenDoi, {
            key: 0,
            doi: __props.entity?.entity?.doi
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["doi"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})